import z from "zod";
import { SexEnum, type OrderInfo, type Patient } from "./orders.types";

export const patientSchema = z.object({
  firstName: z.string().min(2, "Le prénom est requis"),
  lastName: z.string().min(2, "Le nom de famille est requis"),
  birthDate: z.date().optional(),
  sex: z.enum(SexEnum).optional(),
}) satisfies z.ZodType<Patient>;

export const orderInfoSchema = z.object({
  dentistId: z.uuid(),
  patient: patientSchema,
}) satisfies z.ZodType<OrderInfo>;
